import { FC } from "react";
import {
  AspectRatio,
  Box,
  Button,
  Card,
  Dialog,
  Flex,
  Select,
  Table,
  Text,
} from "@radix-ui/themes";
import { Submission } from "@/models/database/submissions/Submission.model";
import { formatTimeFromMS } from "../helperFunctions/formatTimeFromMS";
import DateObject from "react-date-object";
import SubmissionsItemActions from "./submissions.item.actions";

export interface SubmissionsItemProps {
  data: Submission;
}

const SubmissionsItem: FC<SubmissionsItemProps> = ({ data }): JSX.Element => {
  const ifPointsIsMS = data.type === "time";

  const points = ifPointsIsMS
    ? formatTimeFromMS(data.points.toString())
    : data.points;

  const timestamp = new DateObject(data.created.toDate()).format(
    "DD.MM.YYYY HH:mm"
  );

  return (
    <Table.Row>
      <Table.RowHeaderCell>{timestamp}</Table.RowHeaderCell>
      <Table.Cell>
        <Flex direction="column" gap="1">
          <Text>{data.challengeName}</Text>
          <Text size="1" color="gray">
            - {data.fieldToCompare}
          </Text>
        </Flex>
      </Table.Cell>
      <Table.Cell>{points}</Table.Cell>
      <Table.Cell>
        {data.screenShotUrl && (
          <Dialog.Root>
            <Dialog.Trigger>
              <Button variant="soft">View</Button>
            </Dialog.Trigger>

            <Dialog.Content size="4">
              <Dialog.Title>Screenshot for {data.username}</Dialog.Title>

              <img src={data.screenShotUrl} alt="Screenshot" />

              <Flex gap="3" mt="4" justify="end">
                <Dialog.Close>
                  <Button variant="soft" color="gray">
                    Close
                  </Button>
                </Dialog.Close>
              </Flex>
            </Dialog.Content>
          </Dialog.Root>
        )}
      </Table.Cell>
      <Table.Cell>
        <Flex align="center" gap="2">
          <Box width="2rem">
            <AspectRatio ratio={1 / 1}>
              <img
                src={data.profileLogoUrl}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
                alt="Profile Logo"
              />
            </AspectRatio>
          </Box>
          <Text size="2">{data.username}</Text>
        </Flex>
      </Table.Cell>
      <Table.Cell>
        <SubmissionsItemActions data={data} />
      </Table.Cell>
    </Table.Row>
  );
};

export default SubmissionsItem;
